type UpdateListener = () => void

let waitingWorker: ServiceWorker | null = null
const listeners = new Set<UpdateListener>()

export function onUpdateAvailable(listener: UpdateListener): () => void {
  listeners.add(listener)
  if (waitingWorker) listener()
  return () => listeners.delete(listener)
}

export function applyUpdate(): void {
  waitingWorker?.postMessage({ type: 'SKIP_WAITING' })
  waitingWorker = null
  window.location.reload()
}

function notify(worker: ServiceWorker): void {
  waitingWorker = worker
  for (const listener of listeners) listener()
}

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return
  window.addEventListener('load', () => {
    void navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        if (registration.waiting) notify(registration.waiting)
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing
          if (!installing) return
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) notify(installing)
          })
        })
      })
      .catch(() => {
        /* PWA je nadogradnja, ne uvjet za rad aplikacije. */
      })
  })
}
